var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Phone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.746,
    height: 16.27,
    viewBox: "0 0 12.746 16.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n        stroke: #101010;\n        stroke-width: 0.25px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-phone_1_",
    "data-name": "icons8-phone (1)",
    className: "cls-1",
    d: "M13.013,4a2.238,2.238,0,0,0-.8.086l-.947.28A3.015,3.015,0,0,0,9.205,6.48c-.592,2.247.085,4.906,1.848,7.9s3.767,4.889,6.032,5.51a3.07,3.07,0,0,0,2.893-.705l.72-.668a2.181,2.181,0,0,0,.275-2.88l-1.041-1.413a2.239,2.239,0,0,0-2.445-.809l-1.628.487c-.068.02-.232-.073-.374-.2h0a5.627,5.627,0,0,1-.98-1.3h0a5.812,5.812,0,0,1-.644-1.4.752.752,0,0,1-.042-.386.189.189,0,0,1,.063-.119h0L15.1,9.39a2.175,2.175,0,0,0,.513-2.507l-.732-1.6h0A2.225,2.225,0,0,0,13.013,4Zm-.087,1.2a1.03,1.03,0,0,1,.86.585l.733,1.6a.959.959,0,0,1-.232,1.122L13.074,9.614a1.392,1.392,0,0,0-.446.87h0a2.383,2.383,0,0,0,.073.823,6.86,6.86,0,0,0,.77,1.7h0a6.424,6.424,0,0,0,1.227,1.6h0a1.582,1.582,0,0,0,1.5.442h0l1.635-.49a1.037,1.037,0,0,1,1.133.371l1.041,1.413a.965.965,0,0,1-.125,1.289l-.72.669a1.89,1.89,0,0,1-1.761.427c-1.832-.5-3.644-2.124-5.314-4.96s-2.2-5.189-1.723-6.985A1.83,1.83,0,0,1,11.61,5.522l.946-.28A1.035,1.035,0,0,1,12.927,5.2Z",
    transform: "translate(-8.87 -3.873)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Phone);
export default __webpack_public_path__ + "static/media/icons8-phone.01c012a531ef2254d345dc1b80fdbd84.svg";
export { ForwardRef as ReactComponent };